<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'General',
          fields: [
            ...this.getCommonFields(),
            new fields.Header({
              text: 'Image with circles will be added automatically.',
              type: 'h4'
            }),
            new fields.WYSIWYG({
              label: 'Title',
              modelPath: [this, 'form', 'title'],
              multilingual: true,
              required: true
            })
          ]
        }
      ]
    }
  }
}
</script>
